import { usePropertyNotifications } from '@/hooks/usePropertyNotifications'

export default function PropertyNotifications({ propertyId }: { propertyId: number }) {
  usePropertyNotifications(propertyId)
  return null
}
